export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'https://localhost:5001',
  // Management console URL; the "Forms" nav item returns there (empty = same origin).
  managementUrl: import.meta.env.VITE_MANAGEMENT_URL ?? '',
  entra: {
    tenantId: import.meta.env.VITE_ENTRA_TENANT_ID ?? 'common',
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
    apiScope: import.meta.env.VITE_API_SCOPE ?? '',
  },
};

/** Reads the target form id from `?formId=` (the management app links here). */
export function resolveFormId(): string | null {
  return new URLSearchParams(window.location.search).get('formId');
}
